import axios from 'axios'

const apiBaseURL = import.meta.env.VITE_APP_API_BASE_URL

export const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export { apiBaseURL }
